import Widget from "lib/widget";
import axios from 'axios';
import $              from "jquery"
import select2        from "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"

class ExportDealerDataWidget extends Widget  {
  bind() {
    this.form = this.root.find('form')
    this.form.find('.loading-spinner').hide()
    bindFormActions.call(this)
    bindRequestReport.call(this)
    this.tenderSelect = $('.tender-select')
  }
}

var bindFormActions = function() {
  // Select 2
  let tender_select = this.form.find(".tender-select")
  $(tender_select).select2({
    placeholder: 'Select',
    allowClear: true,
    theme: "bootstrap"
  }).on('change', (e) => {
    toggleReportBtn.call(this)
  })
}

var toggleReportBtn = function() {
  let tender = this.tenderSelect.val()
  $("#export-dealer-data").toggleClass('hidden', !(tender.length > 0))
}

var bindRequestReport = function() {
  $("#export-dealer-data").on('click', () => {
    generateReportRequest.call(this)
  })
  $(".js-dealers").on('click', () => {
    generateReportRequestDealers.call(this)
  })
}

var generateReportRequestDealers = function() {
  window.location.href= `${this.form.attr('action')}.csv?${jQuery.param(this.form.serializeArray())}`
}

var generateReportRequest = function() {
  let tenders = this.tenderSelect.val()

  $("#export-dealer-data").toggleClass('hidden', true)
  $(".dealer-data-disabled").toggleClass('hidden', false)

  return axios({
    url: `reports.json?tender_ids=${tenders}`,
    method: "POST",
    responseType:'json'
  }).then(response => {
    this.report = response.data.report;
    watchReport.call(this)
  })
}

var watchReport = function() {
  this.interval = setInterval(() => {
    checkReport.call(this)
  }, 1000)
}

let stopWatch = function() {
  clearInterval(this.interval)
}

var checkReport = function() {
  return axios({
    url: `reports/${this.report.id}.json`,
    method: "GET",
    dataType: "json"
  }).done(response => {
    this.report = response.data.report

    if (this.report.ready) {
      stopWatch.call(this)
      $("#export-dealer-data").toggleClass('hidden', false)
      $(".dealer-data-disabled").toggleClass('hidden', true)
      window.location.href = this.report.url;
      console.log("DONE")
    }
  })
}


export default ExportDealerDataWidget
